import gql from 'graphql-tag'

export const ProductVariantFields = gql`
  fragment ProductVariantFields on ProductVariant {
    sku
    title
    __typename
    images {
      thumbnail
      largeProduct
      zoom
      __typename
    }
    product {
      reviews {
        averageScore
        total
        __typename
      }
      url
      __typename
    }
  }
`
